(() => {
  const redirects = {
    "/group-profile": "/pages/group-profile",
    "/group-business": "/pages/group-business",
    "/global-network": "/pages/global-network",
    "/contact": "/pages/contact",
    "/brand-story": "/pages/brand-story",
    "/environmental-association": "/pages/environmental-association",
    "/green-coffee-trade": "/pages/green-coffee-trade",
    "/group-updates": "/pages/group-updates",
    "/h350": "/pages/h350",
    "/papua-new-guinea": "/pages/papua-new-guinea",
    "/company/hong-kong": "/pages/company-hong-kong",
    "/company/papua-new-guinea": "/pages/company-papua-new-guinea",
    "/company/canada": "/pages/company-canada",
    "/company/china": "/pages/company-china",
    "/roasted-coffee/morning-mist": "/pages/roasted-coffee-morning-mist",
    "/roasted-coffee/rosewood-light": "/pages/roasted-coffee-rosewood-light",
    "/roasted-coffee/highland-crimson": "/pages/roasted-coffee-highland-crimson",
    "/roasted-coffee/volcanic-reserve": "/pages/roasted-coffee-volcanic-reserve",
  };
  const languages = ["en", "zh", "fr", "es"];
  const documentLanguages = { en: "en", zh: "zh-Hans", fr: "fr", es: "es" };
  const menuLabels = {
    en: { open: "Menu", close: "Close" },
    zh: { open: "菜单", close: "关闭" },
    fr: { open: "Menu", close: "Fermer" },
    es: { open: "Menú", close: "Cerrar" },
  };
  const assets = window.__libergeonAssets || {};
  let currentLanguage = "en";

  const fixed = (value) => {
    if (!value) return value;
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin) return value;
      if (url.pathname === "/_next/image") {
        const raw = url.searchParams.get("url");
        if (raw && assets[raw]) return assets[raw];
      }
      return assets[url.pathname] || value;
    } catch {
      return value;
    }
  };

  const repairElement = (element) => {
    for (const attribute of ["src", "poster"]) {
      const value = element.getAttribute?.(attribute);
      const next = fixed(value);
      if (value && next !== value) element.setAttribute(attribute, next);
    }
    const srcset = element.getAttribute?.("srcset");
    if (srcset) {
      const next = srcset
        .split(",")
        .map((candidate) => {
          const parts = candidate.trim().split(/\s+/);
          parts[0] = fixed(parts[0]);
          return parts.join(" ");
        })
        .join(", ");
      if (next !== srcset) element.setAttribute("srcset", next);
    }
  };

  const repairTree = (root) => {
    if (root.nodeType === 1) repairElement(root);
    root.querySelectorAll?.("img[src],source[src],video[poster],[srcset]").forEach(repairElement);
  };


  // Localize existing labels before a language template is displayed.
  const languageLabels = [["Libergeon Group home","Libergeon 集团首页","Accueil de Libergeon Group","Inicio de Libergeon Group"],["Language","语言","Langue","Idioma"],["Libergeon H350 studio product presentation","Libergeon H350 产品展示","Présentation du produit Libergeon H350","Presentación del producto Libergeon H350"],["Libergeon H350 product presentation","Libergeon H350 产品展示","Présentation du produit Libergeon H350","Presentación del producto Libergeon H350"],["Libergeon H350 product view","Libergeon H350 产品外观","Vue du produit Libergeon H350","Vista del producto Libergeon H350"],["Libergeon H350 Papua New Guinea design language presentation","Libergeon H350 巴布亚新几内亚设计语言展示","Design du Libergeon H350 inspiré de Papouasie–Nouvelle-Guinée","Diseño del Libergeon H350 inspirado en Papúa Nueva Guinea"],["H350 Papua New Guinea design language presentation","H350 巴布亚新几内亚设计语言展示","Design du H350 inspiré de Papouasie–Nouvelle-Guinée","Diseño del H350 inspirado en Papúa Nueva Guinea"],["Papua New Guinea origin connected with Libergeon global operations","巴布亚新几内亚产地与 Libergeon 全球运营的联系","Origine en Papouasie–Nouvelle-Guinée et activités mondiales de Libergeon","Origen en Papúa Nueva Guinea y operaciones globales de Libergeon"],["Environmental field activity in Papua New Guinea","巴布亚新几内亚环保现场活动","Action environnementale sur le terrain en Papouasie–Nouvelle-Guinée","Actividad ambiental sobre el terreno en Papúa Nueva Guinea"],["Olive Environmental Protection Association","橄榄环境保护协会","Association de protection de l’environnement Olive","Asociación de Protección Ambiental Olive"],["Olive Environmental Protection Association official logo","橄榄环境保护协会官方标志","Logo officiel de l’association de protection de l’environnement Olive","Logotipo oficial de la Asociación de Protección Ambiental Olive"],["Papua New Guinea green coffee warehouse and lot coordination","巴布亚新几内亚生豆仓储与批次管理","Entrepôt de café vert et coordination des lots en Papouasie–Nouvelle-Guinée","Almacén de café verde y coordinación de lotes en Papúa Nueva Guinea"],["Aerial view of a highland community and cultivated landscape in Papua New Guinea","巴布亚新几内亚高地社区与农耕景观航拍","Vue aérienne d’une communauté et de terres cultivées des Hautes Terres de Papouasie–Nouvelle-Guinée","Vista aérea de una comunidad y tierras cultivadas de las Tierras Altas de Papúa Nueva Guinea"],["Libergeon H350 development and design language","Libergeon H350 研发与设计语言","Développement et design du Libergeon H350","Desarrollo y diseño del Libergeon H350"],["Libergeon four-package roasted coffee collection","Libergeon 四款熟豆包装系列","Collection Libergeon de quatre emballages de café torréfié","Colección Libergeon de cuatro envases de café tostado"]];
  const localizeLabels = (root, language) => {
    if (!root) return;
    const ix = {en:0,zh:1,fr:2,es:3}[language];
    const labels = new Map(languageLabels.map(row => [row[0], row[ix]]));
    root.querySelectorAll('[alt],[aria-label],[title]').forEach(el => {
      ['alt','aria-label','title'].forEach(attr => {
        let value = el.getAttribute(attr); if (!value) return;
        let next = labels.get(value) || value;
        if (language !== 'en') {
          next = next.replace(/ Libergeon roasted coffee package$/, ({zh:' Libergeon 熟豆包装',fr:' — emballage de café torréfié Libergeon',es:' — envase de café tostado Libergeon'})[language]);
          next = next.replace(/ package detail$/, ({zh:' 包装细节',fr:' — détail de l’emballage',es:' — detalle del envase'})[language]);
          next = next.replace(/ detail$/, ({zh:'详情',fr:' — détails',es:' — detalles'})[language]);
        }
        if (next !== value) el.setAttribute(attr,next);
      });
    });
    const textLabels = {
      'GROUP / H350 TECHNOLOGY': ['GROUP / H350 TECHNOLOGY','集团 / H350 技术','GROUPE / TECHNOLOGIE H350','GRUPO / TECNOLOGÍA H350'],
      'ROASTED COFFEE / BRAND PORTFOLIO': ['ROASTED COFFEE / BRAND PORTFOLIO','咖啡熟豆 / 品牌系列','CAFÉS TORRÉFIÉS / COLLECTION','CAFÉ TOSTADO / COLECCIÓN'],
      'Libergeon / Coffee': ['Libergeon / Coffee','Libergeon / 咖啡','Libergeon / Café','Libergeon / Café']
    };
    root.querySelectorAll('p,span,div').forEach(el=>{if(el.children.length)return;const text=el.textContent.trim();if(textLabels[text] && textLabels[text][ix]!==text)el.textContent=textLabels[text][ix];});
  };

  const setMenuState = (button, open) => {
    const navigation = document.getElementById(button.getAttribute("aria-controls"));
    if (!navigation) return;
    navigation.classList.toggle("nav--open", open);
    button.setAttribute("aria-expanded", String(open));
    button.textContent = menuLabels[currentLanguage][open ? "close" : "open"];
  };

  const applyLanguage = (language, preserveScroll = false) => {
    if (!languages.includes(language)) return false;
    const template = document.querySelector(`template[data-libergeon-language="${language}"]`);
    const currentMain = document.querySelector("main");
    const nextMain = template?.content.querySelector("main")?.cloneNode(true);
    if (!currentMain || !nextMain) return false;
    const scrollY = window.scrollY;
    localizeLabels(nextMain, language);
    currentMain.replaceWith(nextMain);
    currentLanguage = language;
    localStorage.setItem("libergeon-language", language);
    document.documentElement.lang = documentLanguages[language];
    nextMain.querySelectorAll(".language-switcher button").forEach((button, index) => {
      const active = languages[index] === language;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", String(active));
    });
    repairTree(nextMain);
    if (preserveScroll) {
      requestAnimationFrame(() => window.scrollTo(0, Math.min(scrollY, document.documentElement.scrollHeight - innerHeight)));
    } else {
      window.scrollTo(0, 0);
    }
    return true;
  };

  const initialize = () => {
    repairTree(document);
    const localeSegment = location.pathname.split("/").filter(Boolean)[0]?.toLowerCase() || "";
    const localeKey = localeSegment.split("-")[0];
    const pathLanguage = languages.includes(localeKey) ? localeKey : null;
    const savedLanguage = localStorage.getItem("libergeon-language");
    const initialLanguage = pathLanguage || (languages.includes(savedLanguage) ? savedLanguage : "en");
    if (initialLanguage !== "en") {
      applyLanguage(initialLanguage);
    } else {
      localizeLabels(document.querySelector("main"), "en");
      currentLanguage = "en";
      document.documentElement.lang = "en";
    }
  };

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes") repairElement(mutation.target);
      mutation.addedNodes.forEach(repairTree);
    }
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["src", "srcset", "poster"],
  });

  document.addEventListener("click", (event) => {
    const languageButton = event.target.closest?.(".language-switcher button");
    if (languageButton) {
      const buttons = [...languageButton.parentElement.querySelectorAll("button")];
      const language = languages[buttons.indexOf(languageButton)];
      if (language) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyLanguage(language, true);
      }
      return;
    }

    const menuButton = event.target.closest?.(".menu-toggle");
    if (menuButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setMenuState(menuButton, menuButton.getAttribute("aria-expanded") !== "true");
      return;
    }

    const anchor = event.target.closest?.("a");
    if (!anchor) return;
    const menu = anchor.closest("nav.nav--open");
    if (menu) {
      const button = document.querySelector(`.menu-toggle[aria-controls="${menu.id}"]`);
      if (button) setMenuState(button, false);
    }
    const url = new URL(anchor.href, location.href);
    const destination = url.origin === location.origin ? redirects[url.pathname] : null;
    if (!destination) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(`${destination}${url.search}${url.hash}`);
  }, true);

  document.addEventListener("submit", (event) => {
    if (event.target.closest?.("main")) event.preventDefault();
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
})();
